import React from 'react';
import { createStackNavigator } from '@react-navigation/stack';
import { useTranslation } from 'react-i18next';
import useTheme from '../../hooks/useTheme';
import { getStackScreenOptions } from '../config/screenOptions';
import { VendorStackParamList } from '../types/navigation.types';
import { createLazyScreen } from '../utils/lazyScreen';

// Lazy load screens
const SupplierListScreen = createLazyScreen(() => import('../../screens/supplier/supplier-list-screen'));
const SupplierDetailScreen = createLazyScreen(() => import('../../screens/supplier/supplier-detail-screen'));
const SupplierEditScreen = createLazyScreen(() => import('../../screens/supplier/supplier-edit-screen'));
const SupplierCaptureScreen = createLazyScreen(() => import('../../screens/supplier/supplier-capture-screen'));

const Stack = createStackNavigator<VendorStackParamList>();

export function VendorStack() {
  const { t } = useTranslation();
  const { colors } = useTheme();

  return (
    <Stack.Navigator screenOptions={getStackScreenOptions(colors)}>
      <Stack.Screen
        name="SupplierList"
        component={SupplierListScreen}
        options={{ title: t('vendor.list', 'Vendor List') }}
      />
      <Stack.Screen
        name="SupplierDetail"
        component={SupplierDetailScreen}
        options={{ title: t('vendor.details', 'Vendor Details') }}
      />
      <Stack.Screen
        name="SupplierEdit"
        component={SupplierEditScreen}
        options={{ title: t('vendor.edit', 'Edit Vendor') }}
      />
      <Stack.Screen
        name="SupplierCapture"
        component={SupplierCaptureScreen}
        options={{ title: t('vendor.capture', 'Add Vendor') }}
      />
    </Stack.Navigator>
  );
}